// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__WidgetCard-module--Yv7b0 {
    position: absolute;
    z-index: 2;
}

.float__WidgetCard-module--q13Tb {
    animation-name: float__WidgetCard-module--q13Tb;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
}

@keyframes float__WidgetCard-module--q13Tb {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(calc(var(--px) * -10));
    }
}

.card__WidgetCard-module--Kv5AR {
    display: flex;
    flex-direction: column;
    gap: calc(var(--px) * 8);
    background: #FFFFFF;
    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);
    border-radius: calc(var(--px) * 24);
    box-shadow: calc(var(--px) * 6) calc(var(--px) * 6) 0 var(--color-neutral-900);
    padding: calc(var(--px) * 16) calc(var(--px) * 18) calc(var(--px) * 14);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/WidgetCard.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,+CAAqB;IACrB,sCAAsC;IACtC,mCAAmC;AACvC;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,4DAA4D;IAC5D,mCAAmC;IACnC,8EAA8E;IAC9E,uEAAuE;AAC3E","sourcesContent":[".wrapper {\n    position: absolute;\n    z-index: 2;\n}\n\n.float {\n    animation-name: float;\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: infinite;\n}\n\n@keyframes float {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(calc(var(--px) * -10));\n    }\n}\n\n.card {\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--px) * 8);\n    background: #FFFFFF;\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);\n    border-radius: calc(var(--px) * 24);\n    box-shadow: calc(var(--px) * 6) calc(var(--px) * 6) 0 var(--color-neutral-900);\n    padding: calc(var(--px) * 16) calc(var(--px) * 18) calc(var(--px) * 14);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__WidgetCard-module--Yv7b0`,
	"float": `float__WidgetCard-module--q13Tb`,
	"card": `card__WidgetCard-module--Kv5AR`
};
export default ___CSS_LOADER_EXPORT___;
